import type { BrowserLogger } from '@/util/logger/BrowserLogger';

const intakeHost = (site = 'datadoghq.com'): string => {
  const parts = site.split('.');
  const extension = parts.pop();
  return `browser-intake-${parts.join('-')}.${extension}`;
};

/**
 * Logs SDK のセッションサンプリングを通さず、SDK と同じ受け口に直接送る。
 * 送り先の設定は初期化済みの Logs SDK から取るため、SDK を読み込まない環境 (L4A など) では送らない。
 */
export const createUnsampledLogger = (): Pick<BrowserLogger, 'info'> => ({
  info(message: string, context?: object): void {
    const config = window.DD_LOGS?.getInitConfiguration();
    if (!config) {
      return;
    }
    const query = new URLSearchParams({
      ddsource: 'browser',
      ddtags: `env:${config.env},service:${config.service}`,
      'dd-api-key': config.clientToken,
    });
    navigator.sendBeacon(
      `https://${intakeHost(config.site)}/api/v2/logs?${query}`,
      JSON.stringify({
        date: Date.now(),
        status: 'info',
        message,
        service: config.service,
        view: { url: location.href },
        ...context,
      })
    );
  },
});
